import React, { useState, useRef, useEffect } from 'react';

const EditorScreeningMyWork = ({renderChevronContainer, articlesPath, initialData, isParent}) => {

  const [expanded, setExpanded] = useState(false);
  const [tableData, setTableData] = useState(false);
  const firstUpdate = useRef(true);

  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
    fetchData();
  }, [expanded])

  const setColumns = () => {
    if(isParent) {
      return [
        {width: '160px'},
        null,
        {width: '160px'},
        {width: '160px'},
        null,
        {width: '160px'}
      ]
    } else {
      return [
        {width: '160px'},
        null,
        {width: '160px'},
        null,
        {width: '160px'}
      ]
    }
  }

  const mapColumns = (dt, row) => {
    if(isParent) {
      return (
        dt.fnAddData( [
          row.submitted_on,
          row.sort_column,
          row.channel_name,
          row.submitting_author,
          row.title,
          row.assigned_editor
      ], false)
      )
    } else {
      return (
        dt.fnAddData( [
          row.submitted_on,
          row.sort_column,
          row.submitting_author,
          row.title,
          row.assigned_editor
      ], false)
      )
    }
  }

  const populateTable = (fetchedTableData) => {
    var dt = $("#editor-screening-table").DataTable({
      columns: setColumns(),
      columnDefs: [
        {targets: [0], orderData: [1]},
        {targets: [1], visible: false}
      ],
      searching: false,
      dom: '<"row">tr<"row"<"large-8 columns pagination-details" <"pull-left"p><"pull-left showing-info"i>><"large-4 columns table-length-container"<"text-right"l>>>',
      "bAutoWidth": false,
      "fnDrawCallback": function(oSettings) {
        if (oSettings.fnRecordsDisplay() == 0) {
          $(oSettings.nTableWrapper).find('.dataTables_paginate').hide();
          $(oSettings.nTableWrapper).find('.dataTables_length').hide();
          $(oSettings.nTableWrapper).find('.dataTables_info').hide();
        } else if (oSettings._iDisplayLength > oSettings.fnRecordsDisplay()) {
          $(oSettings.nTableWrapper).find('.dataTables_info').show();
        } else {
          $(oSettings.nTableWrapper).find('.dataTables_paginate').show();
          $(oSettings.nTableWrapper).find('.dataTables_length').show();
          $(oSettings.nTableWrapper).find('.dataTables_info').show();
        }
      },
    })
    
    dt.api().clear();
    for (var i = 0; i < fetchedTableData.articles.length; i++) {
      let row = fetchedTableData.articles[i];
      mapColumns(dt, row)
    }
    dt.fnSort([[1, 'desc']])
    dt.fnDraw()
  }

  const fetchData = () => {
    if(tableData) {
      populateTable(tableData)
      return;
    }

    $.ajax({
      type: 'GET',
      url: articlesPath,
      data: {state: 'EditorScreening'},
      success: function(data) {
        setTableData(data)
        populateTable(data)
      }
    });
  }

  const renderHeaderRow = () => {
    return (
      <div className="row article-state-row">
        <div className="small-1 columns bubble-container has-tip tip-top" data-tooltip="" id="bubble-tooltip-editor-screening" title={initialData.tooltip}>
          <img src={`https://public.cureus.com/channel-icons/${initialData.color}-bubble.png`} />
          <span className="bubble-text">{initialData.total}</span>
        </div>
        <div className="small-9 columns article-state-label">
          <h4>{initialData.label}</h4>  
          <span>{initialData.blurb}</span>
        </div>
        <div className="small-1 columns chevron-container">
          {renderChevronContainer(expanded, setExpanded)}
        </div>
      </div>
    )
  }

  const renderChannel = () => {
    if(isParent) {
      return <th>Channel</th>
    }
  }

  return (
    <React.Fragment>
      <div className="article-state-row-container">
        {renderHeaderRow()}
        {expanded && 
          <div className="channel-articles-datatable-container">
            <table id="editor-screening-table">
              <thead>
                <tr>
                  <th>Entered queue on</th>
                  <th></th>
                  {renderChannel()}
                  <th>Submitting author</th>
                  <th>Title</th>
                  <th>Assigned curator</th>
                </tr>
              </thead>
              <tbody></tbody>
            </table>
          </div>
        }        
      </div>

    </React.Fragment>
  )
}

export default EditorScreeningMyWork;